import * as React from 'react';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Flex } from 'antd';
import { StyledSelect, StyledMenuItem } from './RowsPerPageSelect.styles';

interface RowsPerPageSelectProps {
  value: number;
  options: number[];
  onChange: (value: number) => void;
}

const RowsPerPageSelect: React.FC<RowsPerPageSelectProps> = ({ value, options, onChange }) => {
  const handleChange = (event: SelectChangeEvent<number>) => {
    onChange(event.target.value as number);
  };

  return (
    <Flex justify='center'>
      <StyledSelect
        value={value}
        onChange={handleChange}
        IconComponent={ExpandMoreIcon}
        variant='standard'
        renderValue={(selected) => ` Show ${selected} rows`}
      >
        {options.map((option) => (
          <StyledMenuItem key={option} value={option}>
            {option}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </Flex>
  );
};

export default RowsPerPageSelect;
